/* eslint-disable react/jsx-curly-newline */
/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable react/jsx-wrap-multilines */
import React from 'react';
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from '@material-ui/pickers';
import 'date-fns';
import MomentUtils from '@date-io/moment';
import {
  Grid,
  Paper,
  InputLabel,
  Select,
  Input,
  MenuItem,
  FormControlLabel,
  Checkbox,
} from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';
import { contentLanguages } from 'components/CreateContentTranslation/contentLanguages';
import { filterOptionsArray } from '../../utils/filters';
import { moment } from '../../utils/momentConfig';
import useStyles from './styles';
import { Status } from '../../pages/labels/labelsStatusContent';
import { returnStatusLabel, getStatusId } from '../../pages/labels';
import { tags, getTagValue } from '../DisplayTag/tags';

moment.updateLocale('en', {
  week: {
    dow: 1,
  },
});

export const DataRangeFilter = ({
  showIsPublishPostFilter = false,
  isByPublishPost = false,
  setIsByPublishPost = null,
  selectedStartDate = new Date(),
  setSelectedStartDate = null,
  selectedEndDate = new Date(),
  setSelectedEndDate = null,
  dateTypeFilter = '',
  setDateTypeFilter = null,
  filterStatus = null,
  setFilterStatus = null,
  writers = [],
  accountManagers = [],
  filterWriter = null,
  setFilterWriter = null,
  filterAccountManager = null,
  setFilterAccountManager = null,
  sites = [],
  filterSite = [],
  setFilterSite = null,
  setPage = null,
  permissions = null,
  filterTag = null,
  setFilterTag = null,
  filterLanguage = null,
  setFilterLanguage = null,
  loading = false,
  customColumnSize = 4,
}) => {
  const classes = useStyles();

  const sortNames = (a, b) => {
    if (a.name > b.name) {
      return 1;
    }
    if (a.name < b.name) {
      return -1;
    }
    return 0;
  };

  const handleDateStartChange = (date) => {
    setSelectedStartDate(moment(date).startOf('day').toDate());
    // eslint-disable-next-line no-unused-expressions
    setPage?.(0);
  };

  const handleDateEndChange = (date) => {
    setSelectedEndDate(moment(date).endOf('day').toDate());
    // eslint-disable-next-line no-unused-expressions
    setPage?.(0);
  };

  const handleFilterStatusChange = (filter) => {
    setFilterStatus(getStatusId(filter.target.value));
    // eslint-disable-next-line no-unused-expressions
    setPage?.(0);
  };

  const handleWritersChange = (writers) => {
    if (writers.target.value === 'null') setFilterWriter(null);
    else setFilterWriter(writers.target.value);
    // eslint-disable-next-line no-unused-expressions
    setPage?.(0);
  };

  const handleAccountManagersChange = (accountManagers) => {
    if (accountManagers.target.value === 'null') setFilterAccountManager(null);
    else setFilterAccountManager(accountManagers.target.value);
    // eslint-disable-next-line no-unused-expressions
    setPage?.(0);
  };

  const handleSitesChange = (site) => {
    if (site.target.value === 'null') setFilterSite(sites);
    else setFilterSite([site.target.value]);
    // eslint-disable-next-line no-unused-expressions
    setPage?.(0);
  };

  const handleTagsChange = (tag) => {
    if (tag.target.value === 'null') setFilterTag(null);
    else setFilterTag(tag.target.value);
    // eslint-disable-next-line no-unused-expressions
    setPage?.(0);
  };

  const handleLanguageChange = (language) => {
    if (language.target.value === 'null') setFilterLanguage(null);
    else setFilterLanguage(language.target.value);
    // eslint-disable-next-line no-unused-expressions
    setPage?.(0);
  };

  const setInitialDateHelper = (addDaysValue) => {
    const date = moment().add(addDaysValue, 'days');
    const returnDate = moment(date).startOf('day').toDate();
    setSelectedStartDate(returnDate);
    return returnDate;
  };

  const setEndDateHelper = (addDaysValue) => {
    const date = moment().add(addDaysValue, 'days');
    const returnDate = moment(date).endOf('day').toDate();
    setSelectedEndDate(returnDate);
    return returnDate;
  };

  const handleDateTypeChange = (value) => {
    const myButtonType = value && value.target ? value.target.value : '';
    setDateTypeFilter(myButtonType);
    if (myButtonType === 'ThisMonth') {
      const initialDate = moment()
        .add(1, 'days')
        .startOf('month')
        .startOf('day')
        .toDate();
      const endDate = moment()
        .add(1, 'days')
        .endOf('month')
        .endOf('day')
        .toDate();
      setSelectedStartDate(initialDate);
      setSelectedEndDate(endDate);
    } else if (myButtonType === 'LastMonth') {
      const initialDate = moment()
        .subtract(1, 'month')
        .startOf('month')
        .startOf('day')
        .toDate();
      const endDate = moment()
        .subtract(1, 'month')
        .endOf('month')
        .endOf('day')
        .toDate();
      setSelectedStartDate(initialDate);
      setSelectedEndDate(endDate);
    } else if (myButtonType === 'FromTheBeginning') {
      const initialDate = moment('2018-01-01', 'YYYY-MM-DD').startOf('day').toDate();
      const endDate = moment().endOf('day').toDate();
      setSelectedStartDate(initialDate);
      setSelectedEndDate(endDate);
    } else {
      const option = filterOptionsArray.filter(
        (dateType) => dateType.id === myButtonType,
      );
      if (option && option[0]) {
        setInitialDateHelper(option[0].initialValueCalc);
        setEndDateHelper(option[0].endValueCalc);
      }
    }
    // eslint-disable-next-line no-unused-expressions
    setPage?.(0);
  };

  const handleIsPublishPostChange = (value) => {
    setIsByPublishPost(value);
    // eslint-disable-next-line no-unused-expressions
    setPage?.(0);
  };

  return (
    <Paper className={classes.paper}>
      <div className={classes.root}>
        <Grid container spacing={1}>
          {showIsPublishPostFilter && (
            <Grid item xs={3}>
              <FormControlLabel
                className={classes.checkbox}
                control={
                  <>
                    <Checkbox
                      checked={isByPublishPost}
                      onChange={() =>
                        handleIsPublishPostChange(!isByPublishPost)
                      }
                      name="isByPublishPost"
                    />
                  </>
                }
                label="by publish post date"
              />
            </Grid>
          )}
          <MuiPickersUtilsProvider utils={MomentUtils}>
            {setSelectedStartDate && (
              <Grid item xs={3}>
                <KeyboardDatePicker
                  variant="inline"
                  format="DD/MM/yyyy"
                  margin="normal"
                  id="date-start"
                  label="Start date"
                  value={moment(selectedStartDate).startOf('day').toDate()}
                  onChange={handleDateStartChange}
                  className={classes.marginDefault}
                  KeyboardButtonProps={{
                    'aria-label': 'change date',
                  }}
                  style={{ width: '100%' }}
                  maxDate={moment(selectedEndDate).endOf('day').toDate()}
                />
              </Grid>
            )}
            {setSelectedEndDate && (
              <Grid item xs={3}>
                <KeyboardDatePicker
                  variant="inline"
                  format="DD/MM/yyyy"
                  margin="normal"
                  id="date-end"
                  label="End date"
                  value={moment(selectedEndDate).endOf('day').toDate()}
                  onChange={handleDateEndChange}
                  className={classes.marginDefault}
                  KeyboardButtonProps={{
                    'aria-label': 'change date',
                  }}
                  style={{ width: '100%' }}
                  maxDate={new Date()}
                />
              </Grid>
            )}
            {setDateTypeFilter && (
              <Grid item xs={3}>
                <InputLabel className={classes.marginTextDate}>
                  Date Types
                </InputLabel>
                <Select
                  id="dateTypeFilter-lookup-id"
                  label="Date Helper"
                  value={dateTypeFilter}
                  onChange={handleDateTypeChange}
                  input={<Input />}
                  className={classes.marginDate}
                  style={{ width: '100%' }}
                >
                  {filterOptionsArray.map((item) => (
                    <MenuItem key={item.id} value={item.id}>
                      {item.name}
                    </MenuItem>
                  ))}
                </Select>
              </Grid>
            )}
          </MuiPickersUtilsProvider>

          {loading ? (
            <Grid item xs={customColumnSize}>
              <Skeleton animation="wave" className={classes.loadingSelect} />
            </Grid>
          ) : permissions?.showSitesFilter ? (
            <Grid item xs={customColumnSize}>
              <InputLabel className={classes.marginText}>Sites</InputLabel>
              <Select
                id="sites-lookup-id"
                value={
                  filterSite && filterSite.length === 1 ? filterSite : 'null'
                }
                onChange={handleSitesChange}
                input={<Input />}
                className={classes.marginDefault}
                style={{ width: '100%' }}
              >
                <MenuItem key="null" value="null" selected>
                  All
                </MenuItem>
                {sites ? (
                  sites.map((item) => (
                    <MenuItem key={item} value={item}>
                      {item}
                    </MenuItem>
                  ))
                ) : (
                  <></>
                )}
              </Select>
            </Grid>
          ) : (
            <></>
          )}

          {setFilterStatus ? (
            <Grid item xs={3}>
              <InputLabel className={classes.marginText}>Status</InputLabel>
              <Select
                id="status-lookup-id"
                value={returnStatusLabel(filterStatus)}
                onChange={handleFilterStatusChange}
                input={<Input />}
                className={classes.marginDefault}
                style={{ width: '100%' }}
              >
                <MenuItem key="null" value="All" selected>
                  All
                </MenuItem>
                {Object.values(Status).map((item) => (
                  <MenuItem key={item} value={item}>
                    {item}
                  </MenuItem>
                ))}
              </Select>
            </Grid>
          ) : (
            <></>
          )}

          {loading ? (
            <Grid item xs={1}>
              <Skeleton animation="wave" className={classes.loadingSelect} />
            </Grid>
          ) : permissions?.showTagsFilter ? (
            <Grid item xs={1}>
              <InputLabel className={classes.marginText}>Tags</InputLabel>
              <Select
                id="tags-lookup-id"
                value={filterTag !== null ? filterTag : 'null'}
                onChange={handleTagsChange}
                input={<Input />}
                className={classes.marginDefault}
                style={{ width: '100%' }}
              >
                <MenuItem key="null" value="null" selected>
                  All
                </MenuItem>
                {Object.keys(tags).map((label) => (
                  <MenuItem value={getTagValue(label)} key={label}>
                    {label}
                  </MenuItem>
                ))}
              </Select>
            </Grid>
          ) : (
            <></>
          )}

          {loading ? (
            <Grid item xs={4}>
              <Skeleton animation="wave" className={classes.loadingSelect} />
            </Grid>
          ) : permissions?.showLanguagesFilter ? (
            <Grid item xs={4}>
              <InputLabel className={classes.marginText}>Languages</InputLabel>
              <Select
                id="language-lookup-id"
                value={filterLanguage !== null ? filterLanguage : 'null'}
                onChange={handleLanguageChange}
                input={<Input />}
                className={classes.marginDefault}
                style={{ width: '100%' }}
              >
                <MenuItem key="null" value="null" selected>
                  All
                </MenuItem>
                {contentLanguages.map(({ code, language }) => (
                  <MenuItem value={code} key={code}>
                    {language}
                  </MenuItem>
                ))}
              </Select>
            </Grid>
          ) : (
            <></>
          )}

          {loading ? (
            <Grid item xs={4}>
              <Skeleton animation="wave" className={classes.loadingSelect} />
            </Grid>
          ) : permissions?.showWritersFilter ? (
            <Grid item xs={4}>
              <InputLabel className={classes.marginText}>Writers</InputLabel>
              <Select
                id="writers-lookup-id"
                value={filterWriter != null ? filterWriter : 'null'}
                onChange={handleWritersChange}
                input={<Input />}
                className={classes.marginDefault}
                style={{ width: '100%' }}
              >
                <MenuItem key="null" value="null" selected>
                  All
                </MenuItem>
                {writers ? (
                  [...writers].sort(sortNames).map((item) => (
                    <MenuItem key={item.id} value={item.id}>
                      {item.name}
                    </MenuItem>
                  ))
                ) : (
                  <></>
                )}
              </Select>
            </Grid>
          ) : (
            <></>
          )}

          {loading ? (
            <Grid item xs={4}>
              <Skeleton animation="wave" className={classes.loadingSelect} />
            </Grid>
          ) : permissions?.showAccountManagerFilter ? (
            <Grid item xs={4}>
              <InputLabel className={classes.marginText}>
                Account managers
              </InputLabel>
              <Select
                id="account-managers-lookup-id"
                value={
                  filterAccountManager != null ? filterAccountManager : 'null'
                }
                onChange={handleAccountManagersChange}
                input={<Input />}
                className={classes.marginDefault}
                style={{ width: '100%' }}
              >
                <MenuItem key="null" value="null" selected>
                  All
                </MenuItem>
                {accountManagers ? (
                  [...accountManagers].sort(sortNames).map((item) => (
                    <MenuItem key={item.email} value={item.email}>
                      {item.name}
                    </MenuItem>
                  ))
                ) : (
                  <></>
                )}
              </Select>
            </Grid>
          ) : (
            <></>
          )}
        </Grid>
      </div>
    </Paper>
  );
};
